<template>
  <div class="homeTopclass">
    <div class="box">
      <div class="boximg">
        <img src="@/assets/logo.png" @click="Jumpto()" alt="">
      </div>
      <div class="boxright">
        <div @click="changeColor(1)">
          <p :style="colornum == 1 ? 'color:rgb(57 108 255)' : ''">网站首页</p>
        </div>
        <div @click="changeColor(2)">
          <p :style="colornum == 2 ? 'color:rgb(57 108 255)' : ''">关于我们</p>
        </div>
        <div @click="changeColor(3)">
          <p :style="colornum == 3 ? 'color:rgb(57 108 255)' : ''">药品专区</p>
        </div>
        <div @click="changeColor(4)">
          <p :style="colornum == 4 ? 'color:rgb(57 108 255)' : ''">器械专区</p>
        </div>
        <div @click="changeColor(5)">
          <p :style="colornum == 5 ? 'color:rgb(57 108 255)' : ''">联系我们</p>
        </div>
        <div @click="changeColor(6)">
          <p :style="colornum == 6 ? 'color:rgb(57 108 255)' : ''">登录</p>
        </div>
        <div @click="changeColor(7)">
          <p :style="colornum == 7 ? 'color:rgb(57 108 255)' : ''">注册</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'

const router = useRouter()
// 使用 ref 使 colornum 成为响应式变量
const colornum = ref(window.sessionStorage.getItem("colornum") || 1)

const Jumpto = () => {
  router.push({
    path: '/index'
  })
  colornum.value = 1
  window.sessionStorage.setItem("colornum", 1)
}

function changeColor (index) {
  colornum.value = index
  window.sessionStorage.setItem("colornum", index)
  const pay = localStorage.getItem('pay')
  router.push({
    path: `${index == 1 ? '/index' : index == 2 ? 'about' : index == 5 ? 'contact' : index == 6 ? 'login' : index == 7 ? 'register' : ''}`
  })
  if (index == 3) {
    if (!pay) {
      ElMessage({
        message: '请先完成登录！',
        type: 'warning',
      })
      return
    }
    if (pay == 'noPay') {
      ElMessage({
        message: '请先完成支付！',
        type: 'warning',
      })
      router.push({
        path: '/pay',
        query: { type: '1' }
      })
    }
    if (pay == 'paied') {
      router.push({
        path: '/commodity'
      })
    }
  }
  if (index == 4) {
    if (!pay) {
      ElMessage({
        message: '请先完成登录！',
        type: 'warning',
      })
      return
    }
    if (pay == 'noPay') {
      ElMessage({
        message: '请先完成支付！',
        type: 'warning',
      })
      router.push({
        path: '/pay',
        query: { type: '2' }
      })
    }
    if (pay == 'paied') {
      router.push({
        path: '/instrument'
      })
    }
  }
}
</script>

<style scoped lang="less">
.homeTopclass {
  width: 100%;
  height: 43px;
  background: #ffffff;
  box-shadow: 0px 5px 10px 0px rgba(4, 0, 0, 0.1);

  .box {
    height: 100%;
    margin: 0px 181px;
    display: flex;
    justify-content: space-between;
    .boximg img {
      height: 22px;
      margin-top: 10px;
    }
    .boximg img:hover {
      cursor: pointer;
    }
    .boxright {
      display: flex;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #000;
      p {
        margin-right: 50px;
      }
      p:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
